import { FormInstance } from 'antd';
import { useEffect } from 'react';

import { formatPhoneNumber } from '~/core/helpers';
import { CustomerDataModel } from '~/core/models';
import { useEstimateContext } from '~/legacy/easy-estimator-page/context/estimateContext';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectSelectedCustomerData,
  updateSelectedCustomerData,
} from '~/redux/slices/customerData';

const useLoadCustomerDataForm = (form: FormInstance<CustomerDataModel>) => {
  const dispatch = useAppDispatch();

  const location = useAppSelector((state) => state.zipcode);

  const selectedCustomerData = useAppSelector(selectSelectedCustomerData);

  const { fetchedEstimate } = useEstimateContext();

  useEffect(() => {
    const phone = fetchedEstimate?.customerPhone ?? '';
    const alternatePhone = fetchedEstimate?.customerAlternatePhone ?? '';
    const swapPhones = !phone.length && alternatePhone.length > 0;

    dispatch(
      updateSelectedCustomerData({
        customerName: fetchedEstimate?.customerName || '',
        address1: fetchedEstimate?.customerAddress1 || '',
        address2: fetchedEstimate?.customerAddress2,
        email: fetchedEstimate?.customerEmail || '',
        phone: formatPhoneNumber(swapPhones ? alternatePhone : phone),
        alternatePhone: swapPhones ? '' : alternatePhone,
        city: location.city || fetchedEstimate?.customerCity || '',
        state: location.state || fetchedEstimate?.customerState || '',
        zip: location.zipcode || fetchedEstimate?.customerZip || '',
        subject: '',
        confirmName: false,
        confirmAddress: false,
      })
    );
  }, [
    location.city,
    location.state,
    location.zipcode,
    fetchedEstimate,
    dispatch,
  ]);

  useEffect(() => {
    form.setFieldsValue({
      ...selectedCustomerData,
    });
  }, [form, selectedCustomerData]);

  return {};
};

export default useLoadCustomerDataForm;
